export default __webpack_public_path__ + "static/layer5-community-playfield-3ee13896d523f781eb3ca07873e719f2.webp";